import { useState } from "react"
import { Button, StackView } from "@planningcenter/tapestry-react"
import { api } from "utils/api"
import { isPresent } from "utils/helpers"
import { arrayOf, bool, func, number, object, shape, string } from "prop-types"
import { StatusMessage } from "components/ui"
import RegistrationContact from "components/admin/registration_contact"

const RegistrantContact = ({
  registration,
  suggestedPeople,
  onChange,
  isAdmin = false,
  isSaveDisabled = false
}) => {
  const [isEditing, setIsEditing] = useState(false)
  const [saveStatus, setSaveStatus] = useState({})
  const [pendingResponsiblePersonAcid, setPendingResponsiblePersonAcid] = useState(
    registration.responsiblePerson?.account_center_id
  )

  const handleCancel = () => {
    setSaveStatus({})
    setPendingResponsiblePersonAcid(registration.responsiblePerson?.account_center_id)
    setIsEditing(false)
  }

  const handleSave = async () => {
    if (registration.responsiblePerson?.account_center_id !== pendingResponsiblePersonAcid) {
      onChange({ isSaving: true })
      setSaveStatus({
        isFetching: true,
        text: "Saving...",
        icon: "spinner"
      })
      const { person: newResponsiblePerson, registration: newRegistration } = await api.put(
        registration.paths.showResponsiblePerson,
        {
          new_person_account_center_id: pendingResponsiblePersonAcid
        }
      )
      onChange({ isSaving: false, changes: { newResponsiblePerson, newRegistration } })
      setIsEditing(false)
      setSaveStatus({})
    }
  }

  const handleEdit = () => {
    setIsEditing(true)
  }

  const handleSelect = accountCenterPerson => {
    setPendingResponsiblePersonAcid(accountCenterPerson.account_center_id)
  }

  return (
    <>
      <div className="d-f ai-c jc-sb mb-2">
        <h1 className="h4 fw-600 mb-0">Registration contact</h1>
        {isEditing ? (
          <StackView axis="horizontal" alignment="center" distribution="end">
            {isPresent(saveStatus) && <StatusMessage {...saveStatus} />}
            <Button
              title="Cancel"
              size="xs"
              variant="outline"
              disabled={isSaveDisabled || saveStatus.isFetching}
              onClick={handleCancel}
              marginHorizontal={1}
            />
            <Button
              title="Save"
              size="xs"
              disabled={isSaveDisabled || saveStatus.isFetching}
              theme="create"
              onClick={handleSave}
            />
          </StackView>
        ) : (
          <>
            {!registration.isCanceled && (
              <Button title="Edit" size="xs" variant="outline" onClick={handleEdit} />
            )}
          </>
        )}
      </div>
      <RegistrationContact
        onSelect={handleSelect}
        responsiblePerson={registration.responsiblePerson}
        suggestedPeople={suggestedPeople}
        editMode={isEditing}
        isAdmin={isAdmin}
        isSaving={isPresent(saveStatus)}
      />
    </>
  )
}

RegistrantContact.propTypes = {
  registration: shape({
    isCanceled: bool,
    paths: shape({
      showResponsiblePerson: string.isRequired
    }).isRequired,
    responsiblePerson: shape({
      account_center_id: number.isRequired
    })
  }).isRequired,
  suggestedPeople: arrayOf(object),
  onChange: func.isRequired,
  isAdmin: bool,
  isSaveDisabled: bool
}

export default RegistrantContact
